import { useState } from 'react'
import './App.css'
import { Block } from './components/block'
import { Box } from '@chakra-ui/react'
import { AccountProvider } from './components/ui/account-context';
import { ChatbotProvider } from './components/ui/chatbot-context';
import { AuthProvider } from './components/ui/auth-context';
import { UserThemeSetter } from './components/ui/user-theme-setter';
import { Toaster } from './components/ui/toaster';

function App() {
    const [fontFamily, setFontFamily] = useState('Proxima Nova');

    const handleFontChange = (e: any) => {
        //console.log(e.target.id);
        e.stopPropagation();
        setFontFamily(e.target.id);
    }

    return (
        <AuthProvider>
            <UserThemeSetter />
            <AccountProvider>
                <ChatbotProvider>
                    <Box>
                        {/* <Box color={'black'} ><nys-unavheader hideSearch></nys-unavheader></Box> */}
                        <Block fontFamily={fontFamily} setFontFamily={handleFontChange} />
                        <Toaster />
                    </Box>
                </ChatbotProvider>
            </AccountProvider>
        </AuthProvider>
    )
}

export default App
